import React from "react";
import { CertifierDashboardTemplate } from "themes/application/certifier/pages";
import { CertifierDashboardViewStore } from "application/certifier/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new CertifierDashboardViewStore(rootStore, componentProps),
    "certifierDashboardViewStore"
)
class CertifierDashboard extends React.Component {
    render() {
        return <CertifierDashboardTemplate {...this.props} />;
    }
}

export default CertifierDashboard;
